import React, { useEffect, useRef } from 'react';
import Select, { components } from 'react-select';

// Custom Option component with check mark for selected items
const CustomOption = (props) => {
  const { isSelected } = props;

  return (
    <components.Option {...props}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
        <span>{props.label}</span>
        {isSelected && (
          <span style={{
            color: '#123550',
            fontWeight: '600',
            fontSize: '16px',
            marginLeft: '8px'
          }}>
            ✓
          </span>
        )}
      </div>
    </components.Option>
  );
};

// Custom MultiValue component with check mark in chips
const CustomMultiValue = (props) => {
  return (
    <components.MultiValue {...props}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <span style={{
          color: '#10b981',
          fontWeight: '600',
          fontSize: '14px'
        }}>
          ✓
        </span>
        {props.children}
      </div>
    </components.MultiValue>
  );
};

const DestinationField = ({
  options,
  value,
  onChange,
  customFilterOption,
  onMenuOpen,
  menuPortalTarget,
  validationError,
  isOpen,
  onInputChange,
  isDisabled
}) => {
  const selectRef = useRef(null);

  useEffect(() => {
    if (isOpen && selectRef.current) {
      selectRef.current.focus();
    }
  }, [isOpen]);

  return (
    <div className={`sf-field-content ${validationError ? 'sf-field-error' : ''}`}>
      {/* label nativo asocia el toque en cualquier parte del recuadro con el input,
          así iOS abre el teclado sin necesitar focus() programático */}
      <label htmlFor="sf-destination-input" style={{ display: 'block' }}>
      <Select
        ref={selectRef}
        inputId="sf-destination-input"
        isMulti
        className="react-select-container react-select-no-container"
        classNamePrefix="react-select"
        styles={{
          control: (base) => ({
            ...base,
            border: '1px solid #e0e0e0',
            boxShadow: 'none',
            minHeight: '40px',
            backgroundColor: '#ffffff',
            borderRadius: '8px',
            '&:hover': {
              borderColor: '#123550',
            },
          }),
          valueContainer: (base) => ({
            ...base,
            padding: '2px 8px',
            gap: '4px',
            flexWrap: 'wrap',
          }),
          input: (base) => ({
            ...base,
            margin: 0,
            padding: 0,
            color: '#1e293b',
            fontSize: '16px',
          }),
          multiValue: (base) => ({
            ...base,
            backgroundColor: '#e8f5e9',
            borderRadius: '6px',
            border: '1px solid #10b981',
          }),
          multiValueLabel: (base) => ({
            ...base,
            color: '#123550',
            fontSize: '13px',
            padding: '2px 2px 2px 6px',
          }),
          multiValueRemove: (base) => ({
            ...base,
            color: '#123550',
            ':hover': {
              backgroundColor: '#123550',
              color: 'white',
            },
          }),
          option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected
              ? '#f0f4ff'
              : state.isFocused
                ? '#f7f7f7'
                : 'white',
            color: '#1e293b',
            cursor: 'pointer',
            ':active': {
              backgroundColor: '#f0f4ff',
            },
          }),
        }}
        onMenuOpen={onMenuOpen}
        onInputChange={(inputValue, action) => {
          // Notificar al padre cuando el usuario está escribiendo
          if (onInputChange && action.action === 'input-change') {
            onInputChange(inputValue);
          }
        }}
        value={options.filter(opt => value.includes(opt.value))}
        onChange={(selectedOptions) => {
          onChange(selectedOptions ? selectedOptions.map(option => option.value) : []);

          // Volver a poner el cursor en el input después de seleccionar
          setTimeout(() => {
            if (selectRef.current) {
              selectRef.current.focus();
            }
          }, 50);
        }}
        options={options}
        placeholder="Buscar destinos..."
        controlShouldRenderValue={true}
        noOptionsMessage={({ inputValue }) =>
          inputValue ? `No se encontró "${inputValue}"` : "Escribe para buscar destinos..."
        }
        isDisabled={isDisabled}
        isClearable={false}
        isSearchable={!isDisabled}
        blurInputOnSelect={false}
        closeMenuOnSelect={false}
        filterOption={customFilterOption}
        autoFocus={isOpen}
        components={{
          Option: CustomOption,
          MultiValue: CustomMultiValue,
          DropdownIndicator: () => null,
          IndicatorSeparator: () => null,
          ClearIndicator: () => null
        }}
      />
      </label>
    </div>
  );
};

export default DestinationField;
